import { useSelector } from "react-redux";
import { selectEquivalencySettings } from "src/store/projectSelectors";

const useEquivalencyConstants = () => {
  const periodEquivalency = useSelector(selectEquivalencySettings);
  const globalConstants = useSelector((state) => state.global?.constants) || {};

  return {
    flightCO2e:
      periodEquivalency?.flightCO2e ??
      globalConstants?.NY_LON_FLIGHT_CO2E_KG?.current,
    carCO2e:
      periodEquivalency?.carCO2e ??
      globalConstants?.AVG_CAR_UK_CO2E_KG?.current,
  };
};

export default useEquivalencyConstants;
